module.exports = __webpack_public_path__ + "static/2-7c9b48d4b6ee3627b4b09be754206e25.jpg";